import React from 'react';
import Tracker from '#app/helpers/Tracker';
import { RoboMetrics } from '#app/constants/metrics/robo';
import {
  ActionButtons,
  AppDescription,
  AppName,
  BannerContainer,
  BannerContent,
  CloseButton,
  DownloadButton,
  TextContent,
} from '#app/pages/MainPage/components/styles';

const MobileAppBanner = ({ appStoreUrl, onClose }) => {
  const appName = 'whiteswan (белый лебедь)';
  const description = 'Скачайте приложение';

  const handleDownloadClick = () => {
    // Определяем платформу для аналитики
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      Tracker.reachGoal(RoboMetrics.ROBO_IOS);
    } else if (/android/i.test(userAgent)) {
      Tracker.reachGoal(RoboMetrics.ROBO_ANDROID);
    }
  };

  return (
    <BannerContainer>
      <BannerContent>
        <TextContent>
          <AppName>{appName}</AppName>
          <AppDescription>{description}</AppDescription>
        </TextContent>
      </BannerContent>

      <ActionButtons>
        <DownloadButton
          href={appStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleDownloadClick}
        >
          Скачать
        </DownloadButton>

        <CloseButton onClick={onClose} aria-label="Закрыть">
          ×
        </CloseButton>
      </ActionButtons>
    </BannerContainer>
  );
};

export default MobileAppBanner;
